import { FormClassRetire, YesOrNoFlug } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkBorder from "../../components/atoms/TkBorder";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "explanatoryText",
    lineTitle: labelids.labelid.LBLW410004_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "退職者名",
    keyword: "retirementStaffName",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "demanderName",
    type: "text",
  },
  {
    title: "請求者現住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "text",
  },
  {
    title: "請求者現住所（郵便番号以外）",
    keyword: "address",
    type: "text",
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "text",
  },
  {
    title: "メールアドレス",
    keyword: "demanderEmail",
    type: "text",
  },
  {
    title: "続柄",
    keyword: "demanderRelationship",
    type: "nodeInLine",
  },
  {
    title: "退職者からの生計維持の有無",
    keyword: "livelihoodFromRetireeFlg",
    type: "radio",
    disabled: true,
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "あなたと同順位の請求権保持者の有無",
    keyword: "demanderFlg",
    type: "radio",
    disabled: true,
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "①「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathCertificate",
    type: "nodeInLine",
    id: FormClassRetire["「死亡診断書」又は「死体検案書」（写）"],
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodSupportRelatives",
    type: "nodeInLine",
    showLine: false,
    id: FormClassRetire["生計維持に関する調査書（様式11号）"],
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodNoSupportRelatives",
    type: "nodeInLine",
    showLine: false,
    id: FormClassRetire["生計維持に関する調査書（様式11号）"],
  },
  {
    title: "④内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "commonLawRelationship",
    type: "nodeInLine",
    showLine: false,
    id: FormClassRetire["生計維持に関する調査書（様式11号）"],
  },
  {
    title: "⑤職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certificateOfResidence",
    type: "nodeInLine",
    showLine: false,
    id: FormClassRetire["職員の死亡当時の住民票の謄本"],
  },
  {
    title: "⑥その他、事実上の配偶者であることを証明する書類",
    keyword: "lawfulPartner",
    type: "nodeInLine",
    showLine: false,
    id: FormClassRetire["事実上の配偶者であることを証明する書類"],
  },
  {
    keyword: "textDocument",
    type: "lineTitle",
    lineTitle: (
      <>
        必要書類に戸籍謄本又は委任状が含まれる場合には、以下に郵送してください。
        <br />
        <TkBorder>
          【郵送先】〒105－8486 <br />
          　　　　　東京都港区虎ノ門４－３－１３　ヒューリック神谷町ビル９階
          <br />
          　　　　　独立行政法人福祉医療機構　共済部退職給付課　宛
        </TkBorder>
      </>
    ),
  },
];

export { fakeTableList };
